/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import { Popup, Icon } from 'semantic-ui-react'

import style from './ReportDetails.module.css'
import PDFLink from '../PDFLink'
import LoadingDots from '../LoadingDots/LoadingDots'
import MoreDetails from '../../pages/Kits/More/MoreDetails'

import { showQuestResults } from '../../utils/helpers'

const FETCH_ORDER_DOCUMENTS_INTERVAL = 1000 * 60

export const documentTypes = Object.freeze({
  QUEST_AOE: 'AoeUrl',
  REQ_FORM: 'ReqFormPdf',
  ABN_REQ_FORM: 'AbnFormPdf',
  RESULT_DOCUMENT: 'ResultDocument',
  SPECIMEN_LABEL: 'SpecimenLabelPdf',
})

export default function DocumentDetails({ labOrder, refetch }) {
  const { orderDocuments, resultDocuments, reqFormsLoading, documents } =
    labOrder
  // If PDF is not available yet, fetch refetch every 20 seconds
  useEffect(() => {
    let fetchNewDataInterval
    if (fetchNewDataInterval) {
      clearInterval(fetchNewDataInterval)
    }

    if (orderDocuments) {
      if (reqFormsLoading) {
        fetchNewDataInterval = setInterval(() => {
          refetch()
        }, FETCH_ORDER_DOCUMENTS_INTERVAL)
      }
    }

    return () => {
      clearInterval(fetchNewDataInterval)
    }
  }, [orderDocuments, refetch, reqFormsLoading])

  const getDocumentLink = (document) => {
    const names = {
      [documentTypes.QUEST_AOE]: 'Quest AOE Form',
      [documentTypes.REQ_FORM]: 'Requisition Form',
      [documentTypes.ABN_REQ_FORM]: 'ABN Form',
      [documentTypes.SPECIMEN_LABEL]: 'Specimen Label',
    }

    if (document.url) {
      return (
        <p key={document.url} className={style.detailsItem}>
          <PDFLink url={document.url}>
            {names[document.typename]}
            {document.typename === documentTypes.SPECIMEN_LABEL && (
              <Popup
                trigger={<Icon name="info circle" style={{ marginLeft: 2 }} />}
                content="Specimen Label: This label can be used for lab specimens drawn in the provider's office."
                position="right center"
              />
            )}
          </PDFLink>
        </p>
      )
    }

    return null
  }

  // Creating a separate function instead of refactoring getDocumentLink for backwards compatibility
  const renderDynamicDocuments = (dynamicDocuments) => {
    if (!dynamicDocuments.length) return <></>
    return (
      <>
        {dynamicDocuments.map((doc) => {
          return (
            <p key={doc.upload.url} className={style.detailsItem}>
              <PDFLink url={doc.upload.url}>{doc.label}</PDFLink>
            </p>
          )
        })}
      </>
    )
  }

  /// Quest Result Report Base64 to PDF viewer
  const getResultsReportLink = (document) => {
    if (document.url && document.typename === documentTypes.RESULT_DOCUMENT) {
      return (
        <p key={document.url} className={style.detailsItem}>
          <PDFLink url={document.url}>Results Report</PDFLink>
        </p>
      )
    }
    return null
  }

  return (
    <div className={style.documents}>
      {!!orderDocuments.length &&
        orderDocuments.map((document) => getDocumentLink(document))}
      {!!resultDocuments.length &&
        resultDocuments.map((document) =>
          getDocumentLink({
            typename: document.typename,
            url: document.resultsPdfReport.url,
          }),
        )}
      {labOrder.resultDocumentsBase64.pdfBase64 ? (
        <span
          className={style.reportLink}
          onClick={() =>
            showQuestResults(labOrder.resultDocumentsBase64.pdfBase64)
          }
        >
          Results Report
        </span>
      ) : (
        !!resultDocuments.length &&
        resultDocuments.map((document) =>
          getResultsReportLink({
            typename: document.typename,
            url: document.resultsPdfReport.url,
          }),
        )
      )}
      {renderDynamicDocuments(documents)}
      {reqFormsLoading && <LoadingDots text="Loading Order documents" />}

      <MoreDetails data={labOrder} />
    </div>
  )
}
